var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.entity)?_c('div',{class:{
    'animated fadeIn': true,
    card: _vm.card,
  }},[(_vm.card)?_c('div',{staticClass:"card-header"},[_vm._t("header")],2):_vm._e(),_vm._v(" "),_c('div',{class:{ 'card-body': _vm.card }},[_c('form',{staticClass:"form-inline form-inputs",on:{"submit":function($event){$event.preventDefault();_vm.firstPageSearch($event)}}},[_c('div',{staticClass:"form-group col-sm-12 search"})])])]):_vm._e()}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6473a8e5","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/SimpleTable.vue
// module id = 890
// module chunks = 1